import { PageLayout } from '@/components/UI/Layouts/Admin/PageLayout';
import { useNavigate, useParams } from 'react-router-dom';
import { Form, FormData } from './Form';
import toast from 'react-hot-toast';
import { ROUTES } from '@/config/routes';
import { useEffect, useState } from 'react';
import { LoadingSpinner } from '@/components/UI/Common/Admin/LoadingSpinner';
import { useDeleteOne, useGetOne, useUpdateOne } from '@/queries/admin';
import { getBackUrl } from '@/utils/helpers';

export const Edit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data: application } = useGetOne('applications', id!);
  const { mutateAsync: deleteApplication } = useDeleteOne('applications');
  const [formData, setFormData] = useState<Partial<FormData> | null>(null);
  const { mutateAsync: updateApplication } = useUpdateOne('applications');

  useEffect(() => {
    if (!application) return;
    const normalizedApplication: Partial<FormData> = {
      ...application,
      userGroups: application.userGroups.map((group) => group.id),
      applicationGroupId: application.applicationGroupId?.toString(),
      applicationLinks: application.applicationLinks?.map((link) => link.id),
      iconLink: {
        url: application.upload?.path
          ? `${getBackUrl()}/uploads/${application.upload.path}`
          : undefined,
        rawFile: null,
      },
    };
    setFormData(normalizedApplication);
  }, [application]);

  const onSubmit = async (data: FormData) => {
    try {
      await updateApplication({ id: id!, data });
      toast.success('Группа успешно обновлена');
      navigate(ROUTES.ADMIN.APPLICATIONS);
    } catch (error) {
      console.error('Error updating:', error);
      toast.error('Произошла ошибка при обновлении группы');
    }
  };

  const handleDelete = async () => {
    try {
      await deleteApplication({ id: id! });
      toast.success('Приложение успешно удалено');
      navigate(ROUTES.ADMIN.APPLICATIONS);
    } catch (error) {
      console.error('Error deleting:', error);
      toast.error('Произошла ошибка при удалении приложения');
    }
  };

  if (!formData) return <LoadingSpinner className="mt-6" text="Загрузка..." />;

  return (
    <PageLayout
      breadcrumbs={[
        {
          label: 'Приложения',
          href: ROUTES.ADMIN.APPLICATIONS,
        },
        {
          label: 'Редактирование',
          href: '',
        },
      ]}
    >
      <Form onDelete={handleDelete} onSubmit={onSubmit} formData={formData} />
    </PageLayout>
  );
};
